import { api } from './api';

export interface Team {
  id: string;
  name: string;
  leagueId: string;
  clubId?: string;
  ageGroup?: string;
  division?: string;
  season?: string;
  coach?: string;
  homeVenue?: string;
  teamColor?: string;
  logoUrl?: string;
  logoPath?: string;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  // Additional fields that existing components expect
  club?: {
    id: string;
    name: string;
    logoSmallUrl?: string;
  };
  league?: {
    id: string;
    name: string;
  };
  // Stats fields that some components expect
  points?: number;
  wins?: number;
  draws?: number;
  losses?: number;
  goalsFor?: number;
  goalsAgainst?: number;
  playoffEligible?: boolean;
}

export interface TeamResponse {
  success: boolean;
  data: Team[];
}

export const teamService = {
  /**
   * Get teams for a specific league
   */
  async getTeamsByLeague(leagueId: string): Promise<Team[]> {
    const response = await api.get<TeamResponse>(`/leagues/${leagueId}/teams`);
    return response.data.data;
  },

  /**
   * Get team by ID
   */
  async getTeam(teamId: string): Promise<Team> {
    const response = await api.get<{ success: boolean; data: Team }>(`/teams/${teamId}`);
    return response.data.data;
  },

  /**
   * Create a new team (Admin only)
   */
  async createTeam(teamData: Partial<Team>): Promise<Team> {
    const response = await api.post<{ success: boolean; data: Team }>('/teams', teamData);
    return response.data.data;
  },

  /**
   * Update team (Admin only)
   */
  async updateTeam(teamId: string, teamData: Partial<Team>): Promise<Team> {
    const response = await api.put<{ success: boolean; data: Team }>(`/teams/${teamId}`, teamData);
    return response.data.data;
  },

  /**
   * Delete team (Admin only)
   */
  async deleteTeam(teamId: string): Promise<void> {
    await api.delete(`/teams/${teamId}`);
  },

  /**
   * Get team statistics
   */
  async getTeamStats(teamId: string): Promise<any> {
    const response = await api.get<{ success: boolean; data: any }>(`/teams/${teamId}/stats`);
    return response.data.data;
  },

  /**
   * Update team statistics (Admin only)
   */
  async updateTeamStats(teamId: string, stats: any): Promise<Team> {
    const response = await api.put<{ success: boolean; data: Team }>(`/teams/${teamId}/stats`, stats);
    return response.data.data;
  }
};
